import Icon from '../../../components/AppIcon';

const DataCategoryTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'suppliers', label: 'Suppliers', icon: 'Building2', count: 45 },
    { id: 'buyers', label: 'Buyers', icon: 'Users', count: 32 },
    { id: 'ports', label: 'Ports', icon: 'Anchor', count: 18 },
    { id: 'vessels', label: 'Vessels', icon: 'Ship', count: 67 },
    { id: 'enablers', label: 'Enablers', icon: 'Sparkles', count: 10 },
    { id: 'configurations', label: 'System Config', icon: 'Settings', count: 12 }
  ];

  return (
    <div className="bg-card border-b border-border">
      <div className="flex items-center gap-2 px-6 overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-all duration-200 whitespace-nowrap ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-medium' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
            <span className={`px-2 py-0.5 rounded-full text-xs ${
              activeTab === tab?.id
                ? 'bg-primary/10 text-primary' :'bg-muted text-muted-foreground'
            }`}>
              {tab?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DataCategoryTabs;